import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { ViewStateOptions } from '@common/data-models/navigation/viewstate-options';
import { ViewStateOptionsSerializer } from '@common/data-models/serializers/serializers';
import { ViewStateTypes } from '@common/enums/viewstate-types';

import { Record } from './record';
import { SingleFeedViewStateRecord } from './single-feed-viewstate-record';

export class RSSFeedViewStateRecord extends SingleFeedViewStateRecord {
    public initialize() {
        super.initialize();
        this.viewStateType = ViewStateTypes.RSSFEED;
        this.viewStateLayout = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateLayout);
    }
    public get viewStateLayout(): ViewStateOptions {
        return this.getAs<ViewStateOptions>('PSTViewStateLayout');
    }
    public set viewStateLayout(value: ViewStateOptions) {
        this.set('PSTViewStateLayout', value);
    }
    // TODO: Why do we need the feed URL here?
    public get viewStateFeedURL(): string {
        return this.getAs<string>(PSTFieldNames.PSTViewStateFeedURL);
    }
    public set viewStateFeedURL(value: string) {
        this.set(PSTFieldNames.PSTViewStateFeedURL, value);
    }
    public get viewStateFeedID(): string {
        return this.getAs<string>(PSTFieldNames.PSTViewStateFeedID);
    }
    public set viewStateFeedID(value: string) {
        this.set(PSTFieldNames.PSTViewStateFeedID, value);
    }

    public get viewStateDefaultLayout(): string {
        return this.getAs<string>(PSTFieldNames.PSTViewStateDefaultLayout);
    }
    public set viewStateDefaultLayout(value: string) {
        this.set(PSTFieldNames.PSTViewStateDefaultLayout, value);
    }

    public get viewStateDefaultSort(): string {
        return this.getAs<string>(PSTFieldNames.PSTViewStateDefaultSort);
    }
    public set viewStateDefaultSort(value: string) {
        this.set(PSTFieldNames.PSTViewStateDefaultSort, value);
    }

    public get viewStateScope(): number {
        return this.getAs<number>(PSTFieldNames.PSTViewStateFeedScope);
    }
    public set viewStateScope(value: number) {
        this.set(PSTFieldNames.PSTViewStateFeedScope, value);
    }
}
